import './styles/graphic.scss';
import { Child } from 'pym.js';
import * as _ from 'lodash';
import data from './data/data.json';

let graphicParams;

// instantiate pym object
window.pymChild = new Child();

const { pymChild } = window;

// check for URL params
function checkParams() {
  // use the parent URL if we're using the "parent.html" preview page
  // otherwise use the straight url
  let url;
  if (pymChild.parentUrl && pymChild.parentUrl.indexOf('/parent.html') !== -1) {
    url = pymChild.parentUrl;
  } else {
    url = window.location.href;
  }

  console.log('Parent url:', pymChild.parentUrl);
  console.log('Using url:', url);

  // Parse params
  const getParams = function (url) {
    const params = {};
    const parser = document.createElement('a');
    parser.href = url;
    const query = parser.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  graphicParams = getParams(url);
  console.log(graphicParams);
}

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  checkParams();

  // console.log(graphicParams);
  // console.log(data);

  const targetData = _.find(data, obj =>
  // console.log(obj.id);
  // console.log(graphicParams.id);
    obj.id == graphicParams.id);

  console.log('this is the target', targetData);

  const plainText = container
    .append('p')
    .attr('class', 'plaintext')
    .text(targetData.text)
    .on('click', (e) => {
      plainText.attr('class', 'plaintext hide');
      image.attr('class', 'excerpt-image show');

      pymChild.sendHeight();
    });

  const image = container
    .append('div')
    .attr('class', 'excerpt-image show')
    .attr('style', `background-image: url('assets/${targetData.image}');`)
    .on('click', (e) => {
      plainText.attr('class', 'plaintext show');
      image.attr('class', 'excerpt-image hide');

      pymChild.sendHeight();
    });

  const imageHolder = image
    .append('img')
    .attr('src', `assets/${targetData.image}`)
    .attr('class', 'placeholder');
}
